export default __webpack_public_path__ + "static/media/Outcess-video.505c1e1a.mp4";